export const TEXT = {
  PHONE_USAGE: 'We will use this telephone number in the event of any problems with delivery.',
  BACK_TO_STOCK: 'We will use this number to notify the user when the size will be back in stock.',
};

export const REWARD_POINT_SLABS = [
  {
    slabname: 'Nil',
    slabRange: '0 - 1,699',
  },
  {
    slabname: 'Regular',
    slabRange: '1,700 - 2,499',
  },
  {
    slabname: 'Silver',
    slabRange: '2,500 - 7,499',
  },
  {
    slabname: 'Gold',
    slabRange: '7,500 - 14,999',
  },
  {
    slabname: 'Platinum',
    slabRange: '15,000 - 24,999',
  },
  {
    slabname: 'Platinum+',
    slabRange: '25,000+',
  },
];

export const PROFILE_TABS = [
  {
    label: 'Profile',
    value: 0,
  },
  {
    label: 'Address Details',
    value: 10,
  },
  {
    label: 'Points',
    value: 20,
  },
];

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'I Would Rather Not Disclose', value: 'I Would Rather Not Disclose' },
];

export const ADDRESS_TYPE_OPTIONS = [
  { label: 'Shipping', value: 2 },
  { label: 'Billing', value: 1 },
];
